(function ($, Drupal, drupalSettings) {
  'use strict';

  Drupal.behaviors.dlaWebformNode = {
    attach: function attach(context, settings) {
      var self = this;
      self.initWebform(context);

      // Re-apply data form on ajax events to ensure ajax loaded form receives the same data
      $(document).ajaxComplete(function(event, xhr, settings) {

        let params = new URLSearchParams(settings.data);
        let form_id = params.get("form_id");

        // Look for pattern in form_id param name to ensure we only apply this on
        // ajax events that comes from the webform interaction
        if (form_id !== null && form_id.indexOf('webform') !== -1) {
          self.initWebform(context);
        }

      });

    },

    initWebform: function (context) {
      $(context).find('.webform--default .webform-submission-form, .webform--modal .webform-submission-form').each(function () {

        var webformDataContainer = $(this).closest('.dla-webform-data-container');
        var currentWebform = $(this);
        var webformHeader = $(this).find('.dla-webform-header');
        var webformWrapper = $(this).parent('.dla-webform-wrapper');
        var webformImage = $(this).parent('.dla-webform-wrapper').find('.dla-webform-image');

        // set background image if specified in data attribute
        if (webformDataContainer.attr('data-dla-image-src') != null) {
          if (webformDataContainer.attr('data-dla-gradient') != null) {
            var gradient = '';
            switch(webformDataContainer.attr('data-dla-gradient')) {
              case 'sunset':
                gradient = 'radial-gradient(rgba(255,189,23,1) 0%, rgba(251,142,75,0.75) 25%, rgba(248,102,122,0.5) 50%, rgba(248,102,122,0) 100%), ';
                break;
              case 'daytime':
                gradient = 'radial-gradient(rgba(64,255,255,1) 0%, rgba(26,194,255,0.75) 25%, rgba(0,135,255,0.5) 50%, rgba(0,135,255,0) 100%), ';
                break;
              case 'night':
                gradient = 'radial-gradient(rgba(248,102,157,1) 0%, rgba(169,111,203,0.75) 25%, rgba(79,147,227,0.5) 50%, rgba(79,147,227,0) 100%), ';
                break;
              case 'black':
                gradient = 'radial-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 25%, rgba(0, 0, 0, 0.3) 50%, rgba(0, 0, 0, 0) 100%), ';
                break;
              case 'white':
                gradient = 'rgba(255,255,255,.80), ';
                break;
              default:
                gradient = '';
            }
          }

          // Apply styles to element based on layout specified in data-dla-layout
          if ((webformDataContainer.attr('data-dla-layout') == null || webformDataContainer.attr('data-dla-layout') == 'form-over-image')) {
            if (gradient != undefined) {
              currentWebform.css('background-image', gradient + 'url("' + webformDataContainer.attr('data-dla-image-src') + '")');
            } else {
              currentWebform.css('background-image', 'url("' + webformDataContainer.attr('data-dla-image-src') + '")');
            }
          } else {
            if (gradient != undefined) {
              webformImage.css('background-image', gradient + 'url("' + webformDataContainer.attr('data-dla-image-src') + '")');
            } else {
              webformImage.css('background-image', 'url("' + webformDataContainer.attr('data-dla-image-src') + '")');
            }
          }
        }

        // Set text color if specified in data attribute
        if (webformDataContainer.attr('data-dla-text-color') != null) {
          currentWebform.css('color', webformDataContainer.attr('data-dla-text-color'));
        }

        // Set background color if specified in data attribute
        if (webformDataContainer.attr('data-dla-background-color') != null) {
          currentWebform.css('background-color', webformDataContainer.attr('data-dla-background-color'));
        }




        // If webFormHeaderExists, move it outside of div data-drupal-selector="edit-elements" to ensure it stays above the webform
        if (webformHeader.length) {
          webformHeader.insertBefore(currentWebform.find('[data-drupal-selector="edit-elements"]'));
        }

      });
    }

  };

})(jQuery, Drupal, drupalSettings);
